import { render } from "./alertdiypage.vue?vue&type=template&id=3d105a86&scoped=true"
import script from "./alertdiypage.vue?vue&type=script&lang=js"
export * from "./alertdiypage.vue?vue&type=script&lang=js"

import "./alertdiypage.vue?vue&type=style&index=0&id=3d105a86&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d105a86"]])

export default __exports__